import React, { Fragment, useEffect, useState, useRef } from "react";
import SaveEditFirst from "../SaveEdit/SaveEditFirst";
import useClickOutside from "../../../hooks/Screen/useClickOutside";
import useKeyboardShortcuts from "../../../hooks/KeysHandle/useKeyboardShortcuts";
import CreatePortalHOC from "./CreatePortalHOC";
import {
  useLazyFetchPersonInTableQuery,
  useUpdateCustomerDelegationMutation,
} from "../../../utils/customer/customerTable";
import useRequireAuth from "../../../utils/useRequireAuth";
import { Alert, Snackbar } from "@mui/material";
import MuiLoader from "../Loader/MuiLoader";
import { useFetchPermissionTableDataQuery } from "../../../utils/company/companypermissions";
import { ReactComponent as DownArrow } from "../../../assets/images/downArrow.svg";
import { ReactComponent as FedCrossIMG } from "../../../assets/images/fedCrossIMG.svg";
import { useSelector } from "react-redux";
import Loader from "../../UniversalComponents/Loader";
import { checkAccessPermission } from "../../../utils/utilityFunctions/localServices";

const PermissionUsers = ({
  tableidclass,
  FieldType,
  FieldValue,
  FieldChange,
  setDataInputRow,
  UpdateTableField,
  Item,
  Header,
  clientCoord,
  DataRow,
  commonData,
  ItemComplete,
  refetchCustomerData,
  multiData,
  searchBoxDisabled,
  showPermissionList,
  setShowPermisionList,
  authorisedUsers,
  handleSelectPerson,
  handleDeletePerson,
}) => {
  const [inputvalue, setInputValue] = useState([]);
  const inputRef = useRef(null);
  const [overlayStyle, setOverlayStyle] = useState({});
  const [samplestate, setsamplestate] = useState(false);
  const [alert, setAlert] = useState({});
  const inputcloseoutside = useClickOutside(() => {
    setDataInputRow(null);
  });
  const token = useRequireAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: permissionsData } = useFetchPermissionTableDataQuery({ token: token?.token });
  const companyId = JSON.parse(localStorage.getItem("company_data")).company_id;

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const formatDateForInput = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const [fetchPersonInTable, { data: personTableData, isFetching }] = useLazyFetchPersonInTableQuery();
  const [updateCustomerDelegation, { isLoading: delegationLoading }] = useUpdateCustomerDelegationMutation();
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId });
  };
  useEffect(() => {
    fetchPersonData("");
  }, []);
  const handleCheck = (e) => {
    setSearchTerm(e.target.value);
  };

  const customerId = ItemComplete?.customer_id?.id;

  const handleCloseAlert = () => {
    setAlert((prevState) => ({ ...prevState, open: false }));
  };

  const options = permissionsData?.data?.data;

  console.log(options, "options");

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const centeredLoader = () => (
    <div className="bg-container-spinner h-full">
      <div className="spinner">Loading...</div>
    </div>
  );

  const userData = useSelector((store) => store?.user);

  // {getMultiPersonSelection(true, inputvalue, clientCoord)}
  return (
    <>
      <div className="flex items-end">
        {showPermissionList && (
          <CreatePortalHOC
            isOpen={true}
            onClose={() => {}}
            position={clientCoord}
            noBackground
            noBoxShadow
            verticalDist={0}
          >
            <div
              className={` !p-0 `}
              style={{ width: clientCoord?.element?.width ? `${clientCoord.element.width - 20}px` : "auto" }}
              ref={inputcloseoutside}
            >
              <div className="w-[445px] bg-white rounded-md border shadow-3 pt-3 mb-6 absolute z-[1] ">
                {false && (
                  <div className="relative ml-2 my-2">
                    <div
                      className="flex justify-between items-center w-[270px] h-[35px] p-1 border border-DFE2E5 bg-white cursor-pointer rounded-[5px] px-2 text-383838 text-12 font-400"
                      onClick={toggleDropdown}
                    >
                      {selectedOption ? (
                        selectedOption.group_name.value
                      ) : (
                        <span className="text-gray-300 font-500">Select Role</span>
                      )}
                      <span className={`transition-transform ${isOpen ? "rotate-180" : ""}`}>
                        <DownArrow fill="#535252" />
                      </span>
                    </div>
                    {isOpen && (
                      <div className="absolute z-10 w-[270px] border border-gray-300 bg-white shadow-lg rounded-[5px]  text-383838 text-12 font-400">
                        {options?.map((option, index) => (
                          <div
                            key={index}
                            className="cursor-pointer hover:bg-gray-300 p-1 px-2"
                            onClick={() => handleOptionSelect(option)}
                          >
                            {option.group_name.value}
                          </div>
                        ))}
                      </div>
                    )}
                    {selectedOption && <p className="mt-2 font-bold">{selectedOption.value}</p>}
                  </div>
                )}

                <div>
                  {checkAccessPermission("Delegation") && !searchBoxDisabled && (
                    <input
                      type="text"
                      placeholder="Type a name or email address"
                      className="ml-2 w-[270px] h-[38px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-2"
                      value={searchTerm}
                      onChange={handleCheck}
                    />
                  )}

                  {authorisedUsers && (
                    <div className="pb-3 align-center ">
                      <h3 className="text-14 font-500 ml-4 mb-2 ">Assigned</h3>
                      <ul
                        className="list-none  overflow-y-auto no-scrollbar"
                        style={{ maxHeight: checkAccessPermission("Delegation") ? "70px" : "150px" }}
                      >
                        {delegationLoading && <Loader isOpen={delegationLoading} />}
                        {Array.isArray(authorisedUsers) &&
                          authorisedUsers?.map((eachInput, index) => {
                            const initials = eachInput.name
                              .split(" ")
                              .filter((word) => word.length > 0)
                              .map((word) => word.charAt(0).toUpperCase())
                              .slice(0, 2)
                              .join("");
                            return (
                              <li
                                key={index}
                                className="list-none cursor-pointer py-1"
                                onClick={(e) =>
                                  Boolean(checkAccessPermission("Delegation")) && handleDeletePerson(eachInput, true)
                                }
                              >
                                <div className="flex justify-between items-center">
                                  <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                                    <div className="bg-white text-10 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                      {initials}
                                    </div>
                                    <p className="mb-1 ">{eachInput.name}</p>
                                  </div>
                                  <div className="pr-6 mb-1">
                                    <FedCrossIMG />
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  )}
                  {checkAccessPermission("Delegation") && (
                    <div>
                      <div>
                        <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
                      </div>
                      <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] h-[75px] overflow-y-auto no-scrollbar">
                        {isFetching && <Loader isOpen={delegationLoading} />}

                        {personTableData &&
                          personTableData
                            ?.filter(
                              (eachInput) =>
                                eachInput.name.toLowerCase().includes(searchTerm || "") &&
                                !(
                                  Array.isArray(inputvalue) &&
                                  inputvalue?.some((eachValue) =>
                                    eachValue.name.toLowerCase().includes(eachInput.name.toLowerCase())
                                  )
                                )
                            )
                            .map((eachInput, index) => {
                              const initials = eachInput.name
                                .split(" ")
                                .filter((word) => word.length > 0)
                                .map((word) => word.charAt(0).toUpperCase())
                                .slice(0, 2)
                                .join("");

                              return (
                                <div className="flex space-x-2 cursor-pointer" key={index}>
                                  <div className="bg-white text-10 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                    {initials}
                                  </div>
                                  <li onClick={(e) => handleSelectPerson(e, eachInput)}>{eachInput.name}</li>
                                </div>
                              );
                            })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </CreatePortalHOC>
        )}
        <div className="pt-1 space-x-1 flex items-end">
          {Array.isArray(inputvalue) &&
            inputvalue
              ?.filter((assigned, index) => index < 3)
              .map((eachInput, index) => {
                const initials = eachInput.name
                  .split(" ")
                  .filter((word) => word.length > 0)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(0, 2)
                  .join("");

                return (
                  <div key={index} className="relative">
                    <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300  p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                      {initials}
                    </div>
                  </div>
                );
              })}
          {inputvalue?.length > 3 && (
            <div className="">
              <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300   w-7 h-5 flex items-center justify-center rounded-full border-[1px]">
                + {inputvalue?.length - 3}
              </div>
            </div>
          )}
        </div>
      </div>
      {alert?.open && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert?.open}
          onClose={handleCloseAlert}
          key={"top" + "right"}
          autoHideDuration={1000}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={alert?.type || "success"} // 'success' for green, 'error' for red
            sx={{
              backgroundColor: alert?.type === "success" ? "green" : "red",
              color: "white",
            }}
          >
            {alert?.message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};
export default PermissionUsers;
